/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAdminOpenRouterKeysSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAdminOpenRouterKeysRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAdminOpenRouterKeysSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAdminOpenRouterKeysSecurity$outboundSchema: z.ZodMiniType<
  ListAdminOpenRouterKeysSecurity$Outbound,
  ListAdminOpenRouterKeysSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAdminOpenRouterKeysSecurityToJSON(
  listAdminOpenRouterKeysSecurity: ListAdminOpenRouterKeysSecurity,
): string {
  return JSON.stringify(
    ListAdminOpenRouterKeysSecurity$outboundSchema.parse(
      listAdminOpenRouterKeysSecurity,
    ),
  );
}

/** @internal */
export type ListAdminOpenRouterKeysRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAdminOpenRouterKeysRequest$outboundSchema: z.ZodMiniType<
  ListAdminOpenRouterKeysRequest$Outbound,
  ListAdminOpenRouterKeysRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listAdminOpenRouterKeysRequestToJSON(
  listAdminOpenRouterKeysRequest: ListAdminOpenRouterKeysRequest,
): string {
  return JSON.stringify(
    ListAdminOpenRouterKeysRequest$outboundSchema.parse(
      listAdminOpenRouterKeysRequest,
    ),
  );
}
